import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M6.75 9.67a.76.76 0 0 1-.75.75H3a.75.75 0 0 1 0-1.5h3a.75.75 0 0 1 .75.75ZM6 12.25H3a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5ZM3 7.08h9a.75.75 0 0 0 0-1.5H3a.75.75 0 0 0 0 1.5Zm0-3.33h9a.75.75 0 0 0 0-1.5H3a.75.75 0 0 0 0 1.5Zm10.5 5.31a.76.76 0 0 0-1.06.06L10 11.91l-1.47-1.44a.75.75 0 0 0-1.06 1.06l2 2a.75.75 0 0 0 .53.22.78.78 0 0 0 .54-.25l3-3.38a.76.76 0 0 0-.04-1.06Z';
const draw24px =
  'M2.25,5A.74.74,0,0,1,3,4.25H18a.75.75,0,0,1,0,1.5H3A.75.75,0,0,1,2.25,5ZM10,18.25H3a.75.75,0,0,0,0,1.5h7a.75.75,0,0,0,0-1.5Zm0-4.67H3a.75.75,0,1,0,0,1.5h7a.75.75,0,0,0,0-1.5Zm11.53-.81a.74.74,0,0,0-1.06,0L15.3,17.94,13,15.62a.75.75,0,1,0-1.06,1.06l2.85,2.85a.77.77,0,0,0,.53.22.79.79,0,0,0,.53-.22l5.7-5.7A.75.75,0,0,0,21.53,12.77ZM3,10.41H18a.75.75,0,0,0,0-1.5H3a.75.75,0,0,0,0,1.5Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const TaskListIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'taskList'),
) as IconWithRender;

TaskListIcon.displayName = 'TaskListIcon';
TaskListIcon.propTypes = Icon.propTypes;
TaskListIcon.renderIcon = (props) => <TaskListIcon {...props} />;
export default TaskListIcon;
